








































































































































































import Vue from "vue";
import HttpClientFactory from "../services/HttpClientFactory";
import AuthenticationServiceFactory from "../services/AuthenticationServiceFactory";
import HttpClient from "../services/HttpClient";
import { HomeIcon, UserIcon, KeyIcon } from "vue-feather-icons";
import { mapActions, mapGetters } from "vuex";
import AuthToken from "../models/authToken";
import ApiUser from "../types/auth/ApiUser";
import UserCredentials from "../types/auth/UserCredentials";
import AuthenticationService from "../services/AuthenticationService";
import ResendConfirmationEmailAlert from "./ResendConfirmationEmailAlert.vue";

export default Vue.extend({
  name: "Login",
  components: {
    HomeIcon,
    UserIcon,
    ResendConfirmationEmailAlert,
    KeyIcon,
  },
  data() {
    return {
      httpClient: {} as HttpClient,
      authenticationService: null as AuthenticationService | null,
      isLoading: false as boolean,
      displayConfirmationEmailAlert: false as boolean,
      email: "" as string,
      rememberMeCheck: false,
      user: {
        username: "",
        password: "",
      } as UserCredentials,
    };
  },
  created() {
    if (this.authenticatedUser) {
      window.location.href = "/dashboard";
    }

    this.httpClient = HttpClientFactory.getInstance();
    this.authenticationService = AuthenticationServiceFactory.getInstance();
  },
  computed: {
    ...mapGetters("auth", {
      authenticatedUser: "user",
    }),
  },
  methods: {
    goToLanding() {
      window.location.href = process.env.VUE_APP_FRONTEND_ENDPOINT;
    },
    ...mapActions("auth", ["setUser"]),
    async getUser(): Promise<any> {
      return this.httpClient.get(
        process.env.VUE_APP_BACKEND_ENDPOINT + "/auth/v1/user"
      );
    },
    isRememberMeChecked() {
      if (localStorage.getItem("rememberCheck")) {
        this.rememberMeCheck = true;
        return true;
      }
      this.rememberMeCheck = false;
      return false;
    },
    persistRememberMeCheck: function(e: any) {
      if (e.target.checked) {
        this.rememberMeCheck = true;
        localStorage.setItem("rememberCheck", "true");
      } else {
        this.rememberMeCheck = false;
        localStorage.removeItem("rememberCheck");
      }
    },
    async login() {
      this.isLoading = true;
      try {
        const { data } = await this.httpClient.post(
          process.env.VUE_APP_BACKEND_ENDPOINT + "/auth/v1/login",
          {
            ...this.user,
            rememberMeCheck: this.rememberMeCheck,
          }
        );

        const token = new AuthToken(data.type, data.token);
        this.httpClient.setToken(token);
        this.authenticationService?.saveAuthTokenToStorage(token);

        try {
          const res: any = await this.getUser();
          const user: ApiUser = res.data;
          await this.setUser(user);
          this.isLoading = false;
          window.location.href = "/dashboard";
        } catch (e) {
          this.isLoading = false;
          const error: any = {
            text: this.$t("auth:login.error"),
            type: "error",
          };
          this.$notify(error);
        }
      } catch (e) {
        this.isLoading = false;
        const code = e.response.data.code;
        if (e.response.status === 403 && code === "email_not_verified") {
          this.email = e.response.data.email;
          this.displayConfirmationEmailAlert = true;
        }

        if (e.response.status === 400 && code === "invalid_credentials") {
          const warn: any = {
            text: this.$t("auth:login." + e.response.data.code),
            type: "warn",
          };
          this.$notify(warn);
        }
      }
    },
  },
});
